import {
  MarkProps as MantineMarkProps,
  Mark as MantineMark,
} from '@mantine/core';

export type MarkProps = MantineMarkProps;

export const Mark = MantineMark;

Mark.displayName = 'Mark';
